export enum EmploymentRegistrationEnumeration {
	REGISTRATION_FROM_1ST_DAY = 'registrationFromFirstDay',
	AFTER_3_MONTHS = 'afterThreeMonths',
}
